import { render, staticRenderFns } from "./SettingsAddEditSubjects.vue?vue&type=template&id=79930175&"
import script from "./SettingsAddEditSubjects.vue?vue&type=script&lang=js&"
export * from "./SettingsAddEditSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports